const PAYMENT_FREQUENCIES = {
  ONE_OFF: 'one_off',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  YEARLY: 'yearly',
  WEEKLY: 'weekly',
  CUSTOM: 'custom',
};

const FREQUENCY_UNITS = {
  MONTHS: 'months',
  YEARS: 'years',
  WEEKS: 'weeks',
};

export { PAYMENT_FREQUENCIES, FREQUENCY_UNITS };
